export const registerComponent = (Vue, name, def) => {
    Vue.component(name, def);
};
export const registerComponents = (Vue, components) => {
    for (const component in components) {
        registerComponent(Vue, component, components[component]);
    }
};
export const registerDirective = (Vue, name, def) => {
    Vue.directive(name, def);
};
export const registerDirectives = (Vue, directives) => {
    for (const directive in directives) {
        registerDirective(Vue, directive, directives[directive]);
    }
};
export const vueUse = (VuePlugin) => {
    if (typeof window !== 'undefined' && window.Vue) {
        window.Vue.use(VuePlugin);
    }
};
export const registerComponentProgrammatic = (Vue, property, component) => {
    Vue.prototype[property] = component;
};
//# sourceMappingURL=vuePlugins.js.map